import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const roles = store.getters && store.getters.roles
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value

      const hasPermission = roles.some(role => {
        return permissionRoles.includes(role)
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`使用方式： v-permission="['editor']"`)
    }
  }
}

// export default {
//   inserted(el, binding, vnode) {
//     const { value = [] } = binding
//     if (!value && value instanceof Array) {
//       throw new Error(`使用方式： v-permission="['editor']"`)
//     }
//     if (value.length > 0) {
//       const permission = store.getters && store.getters.permission
//       for (let item of value) {
//         if (permission[item]) {
//           return true
//         }
//       }
//       return false
//     } else {
//       return true
//     }
//   }
// }
